<template>
  <main>
    <div class="py-4 container-fluid">
      <GridRow>
        <GridCol :size="12">
          <MetaSection title="Penilaian KPI">
            <div class="text-right">
              <!-- <div class="d-flex flex-row gap-3">
                <argon-button :outline="true">Kembali</argon-button>
                <argon-button>Kirim</argon-button>
              </div> -->

              <div class="d-flex gap-3">
                <router-link :to="{ name: 'Penilaian KPI' }">
                  <button class="btn btn-secondary">
                    Kembali
                  </button>
                </router-link>
                <template v-if="['submission', 'resubmission', 'accept_direct_supervisor'].includes(submission_status)">
                  <button class="btn-action btn-action--reject" @click="submitPenilaian(false)">Tolak</button>
                  <button class="btn-action btn-action--primary" @click="submitPenilaian(true)">Terima</button>
                </template>

                <template v-if="submission_status === 'reject_immediate_supervisor'">
                  <button
                    class="btn btn-outline-secondary mr-2"
                    @click="forwardToEmployee()"
                  >
                    Lanjutkan Ke Pegawai
                  </button>

                  <router-link
                    :to="{ name: 'Penilaian KPI Update', params: { employee_id, realization_id, submission_status, periode_id } }"
                  >
                    <button class="btn btn-secondary">Ubah</button>
                  </router-link>
                </template>

              </div>
            </div>
          </MetaSection>
        </GridCol>
        <GridCol :size="12">
            <cards title="Form Realisasi KPI" :withmin="false">
              <div class="d-flex gap-4">
                <div class="bg-secondary rounded-2 p-0" style="width: 92px !important; height: 92px !important; "></div>
                
                <div class="d-flex flex-column gap-3 w-100">
                  <div class="row ">
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Nama</span>
                      <span>{{ employee?.name || '-' }}</span>
                    </div>
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Jabatan</span>
                      <span>{{ employee?.jabatan?.name || '-' }}</span>
                    </div>
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Unit Kerja</span>
                      <span>{{ employee?.unitkerja?.name || '-' }}</span>
                    </div>
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Direct Supervisor</span>
                      <span>{{ employee?.leader?.name || '-' }}</span>
                    </div>
                  </div>
                  
                  <div class="row">
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">No</span>
                      <span>{{ employee?.nip || '-' }}</span>
                    </div>
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Posisi</span>
                      <span>{{ employee?.position || '-' }}</span>
                    </div>
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Periode KPI</span>
                      <span>{{ periode_active?.name || '-' }}</span>
                    </div>
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Immediate Supervisor</span>
                      <span>{{ employee?.unitkerja?.leader?.name || '-' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </cards>
        </GridCol>
        <GridCol :size="12" class="mt-4">
          <!-- <cards title="Form Realisasi KPI" useFooter> -->
            <!-- <template v-slot:footer>
              <div class="text-right">
                <div class="d-flex flex-row-reverse gap-2">
                  <ArgonButton>Lanjutkan</ArgonButton>
                  <ArgonButton :to="{ name: 'Realisasi Target' }" isRouteLink outline>Batalkan</ArgonButton>
                </div>
              </div>
            </template> -->

          <cards title="Form Realisasi KPI" :p="0" class="card--tabs">
            <tabbed-pane
              :tabs="tabs"
            >
              <div class="tab-pane fade show active p-4 pt-0"
                id="pills-penilaian-kinerja"
                role="tabpanel"
                aria-labelledby="pills-penilaian-kinerja-tab"
              >
                
                <div class="mb-2 d-flex items-center justify-content-between flex-column gap-4 pb-4">
                  <h5>Penilaian Kinerja</h5>
                  <!-- <span>
                    <i class="fas fa-ellipsis-h cursor-pointer" aria-hidden="true"></i>
                  </span> -->
                  <div class="d-flex items-center gap-4">
                    <div class="d-flex flex-column border rounded gap-2 p-4" style="min-width: 200px;">
                      <span class="text-sm">Total Bobot</span>
                      <strong class="h4">{{ list_penilaian_kinerja?.realisasi_kinerja?.total_bobot || '-' }}%</strong>
                    </div>
                    <div class="d-flex flex-column border rounded gap-2 p-4" style="min-width: 200px;">
                      <span class="text-sm">Rata-rata Kinerja</span>
                      <strong class="h4">{{ list_penilaian_kinerja?.realisasi_kinerja?.average_kinerja || '-' }}</strong>
                    </div>
                  </div>
                </div>

                <template v-if="list_penilaian_kinerja?.catatan?.direct?.length > 0">
                  <ArgonAlert
                    v-for="item in list_penilaian_kinerja.catatan.direct"
                    :key="item"
                    title="Catatan Atasan 1"
                    color="primary"
                    :dismissible="false"
                  >
                    <p>{{ item?.catatan || '-' }}</p>
                  </ArgonAlert>
                </template>

                <template v-if="list_penilaian_kinerja?.catatan?.immediate?.length > 0">
                  <ArgonAlert
                    v-for="item in list_penilaian_kinerja.catatan.immediate"
                    :key="item"
                    title="Catatan Atasan 2"
                    color="primary"
                    :dismissible="false"
                  >
                    <p>{{ item?.catatan || '-' }}</p>
                  </ArgonAlert>
                </template>

                <!-- <pre>{{ list_penilaian_kinerja }}</pre> -->
                <template v-if="list_penilaian_kinerja?.realisasi_kinerja?.list_kpi?.length > 0">
                  <form-group
                    v-for="(item,index) in list_penilaian_kinerja.realisasi_kinerja.list_kpi"
                    :key="index"
                    :label="item?.kpi || '-'"
                  >
                    <!-- :hint="item?.sub_jumlah || item?.sub_jumlah === 0 ? item?.sub_jumlah : (sumBobotSubKpi(item?.sub_kpi || []))" -->
                    <div class="table-responsive">
                      <table class="table align-middle border border-1 border-light">
                        <thead class="table-light">
                          <tr>
                            <th scope="col" style="min-width: 280px;">Sub KPI</th>
                            <th scope="col">Target</th>
                            <th scope="col">Satuan</th>
                            <th scope="col">Bobot</th>
                            <th scope="col">Realisasi</th>
                            <template v-if="employee_id_login === employee?.immediate_supervisor_id || employee_id_login === employee?.leader_id">
                              <th scope="col">Nilai</th>
                              <th scope="col">Pencapaian</th>
                            </template>
                            <!-- <th scope="col">Total Bobot</th>
                            <th scope="col">Rata-rata</th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(sub, i) in item?.sub_kpi"
                            :key="i"
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <p>{{ sub?.nama_aspek_kpi || '-' }}</p>
                              <p v-if="sub?.catatan" class="text-xs"> {{ sub?.catatan || '-' }}</p>
                            </td>
                            <td width="150">
                              <p>
                                <span v-if="sub?.satuan?.toLowerCase() === 'rupiah'">
                                  {{
                                    new Intl.NumberFormat('id-ID', {
                                      style: 'currency',
                                      currency: 'IDR',
                                      minimumFractionDigits: 0,
                                    }).format(sub?.target || '0')
                                  }}
                                </span>
                                <span v-else>
                                  {{
                                    new Intl.NumberFormat('id-ID', {
                                      minimumFractionDigits: 0,
                                    }).format(sub?.target || '0')
                                  }} 
                                  <span class="text-capitalize">{{ (sub?.satuan?.toLowerCase() === 'persen' ? '%' : sub?.satuan) || '' }}</span>
                                </span>
                              </p>
                            </td>
                            <td width="100">
                              <p>
                                <span class="badge badge-secondary w-100">{{ sub?.satuan || '-' }}</span>
                              </p>
                            </td>
                            <td width="100">
                              <p class="text-center">{{ sub?.bobot ? sub.bobot +'%' : '-' }}</p>
                            </td>
                            <td width="150">
                              <p>
                                <span v-if="sub?.satuan?.toLowerCase() === 'rupiah'">
                                  {{
                                    new Intl.NumberFormat('id-ID', {
                                      style: 'currency',
                                      currency: 'IDR',
                                      minimumFractionDigits: 0,
                                    }).format(sub?.realisasi || '0')
                                  }}
                                </span>
                                <span v-else>
                                  {{
                                    new Intl.NumberFormat('id-ID', {
                                      minimumFractionDigits: 0,
                                    }).format(sub?.realisasi || '0')
                                  }} 
                                  <span class="text-capitalize">{{ (sub?.satuan?.toLowerCase() === 'persen' ? '%' : sub?.satuan) || '' }}</span>
                                </span>
                              </p>
                            </td>
                            <template v-if="employee_id_login === employee?.immediate_supervisor_id || employee_id_login === employee?.leader_id">
                              <td width="100">
                                <p>{{ sub?.nilai || sub?.nilai === 0 ? sub.nilai : '-' }}</p>
                              </td>
                              <td width="100">
                                <p>{{ sub?.pencapaian ? sub.pencapaian +'%' : '-' }}</p>
                              </td>
                            </template>
                            <!-- <td>
                              <p class="text-center">10%</p>
                            </td>
                            <td>
                              <p class="text-center">4.5</p>
                            </td> -->
                          </tr>
                          <!-- <tr>
                            <td colspan="5" class="py-3"></td>
                          </tr>
                          <tr>
                            <td colspan="2"></td>
                            <td colspan=""><strong>Total Bobot</strong></td>
                            <td colspan="2" class="float-right text-center"><strong>{{ sumBobotSubKpi(item?.sub_kpi || []) }}%</strong></td>
                          </tr>
                          <tr>
                            <td colspan="2"></td>
                            <td colspan=""><strong>Rata-rata Kinerja</strong></td>
                            <td colspan="2" class="float-right text-center"><strong>{{ list_penilaian_kinerja?.realisasi_kinerja?.average_kinerja || '-' }}</strong></td>
                          </tr> -->
                        </tbody>
                      </table>
                          <!-- <pre>{{ realisasi_kinerja }}</pre> -->
                    </div>
                  </form-group>
                </template>

                <template v-if="['submission', 'resubmission', 'accept_direct_supervisor'].includes(submission_status)">
                  <div
                    v-if="!is_note_penilaian_kinerja"
                    class="d-flex justify-content-end gap-4"
                  >
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      @click="is_note_penilaian_kinerja = !is_note_penilaian_kinerja"
                    >
                      Berikan Catatan
                    </button>
                  </div>

                  <form-group
                    v-if="is_note_penilaian_kinerja"
                    label="Tulis Catatan"
                  >
                    <p class="text-sm mb-2">Beri catatan untuk karyawan</p>
                    <textarea
                      v-model="note_penilaian_kinerja"
                      class="form-control"
                      rows="5"
                      placeholder="Tulis catatan disini"
                    />
                  </form-group>
                </template>
              </div>

              <div class="tab-pane fade show p-4 pt-0"
                id="pills-penugasan-khusus"
                role="tabpanel"
                aria-labelledby="pills-penugasan-khusus-tab"
              >
                
                <div class="mb-4 d-flex items-center justify-content-between">
                  <h5>Penugasan Khusus</h5>
                  <!-- <span>
                    <i class="fas fa-ellipsis-h cursor-pointer" aria-hidden="true"></i>
                  </span> -->
                </div>

                <template v-if="list_penugasan_khusus?.catatan?.direct?.length > 0">
                  <ArgonAlert
                    v-for="item in list_penugasan_khusus.catatan.direct"
                    :key="item"
                    title="Catatan Atasan 1"
                    color="primary"
                    :dismissible="false"
                  >
                    <p>{{ item?.catatan || '-' }}</p>
                  </ArgonAlert>
                </template>

                <template v-if="list_penugasan_khusus?.catatan?.immediate?.length > 0">
                  <ArgonAlert
                    v-for="item in list_penugasan_khusus.catatan.immediate"
                    :key="item"
                    title="Catatan Atasan 2"
                    color="primary"
                    :dismissible="false"
                  >
                    <p>{{ item?.catatan || '-' }}</p>
                  </ArgonAlert>
                </template>

                <form-group>
                  <div class="table-responsive">
                    <table class="table align-middle border border-1 border-light">
                      <thead class="table-light">
                        <tr>
                          <th scope="col" colspan="2">Jenis Penugasan</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-if="list_penugasan_khusus?.penugasan?.length > 0">
                          <tr
                            v-for="(item) in list_penugasan_khusus.penugasan"
                            :key="item"
                            class="border border-bottom-1 border-light"
                          >
                            <td colspan="2">
                              <!-- <p class="px-2 mt-2">Mengikuti pelatihan nasional maupun internasional dalam setiap bulan </p> -->
                              <div class="py-3 px-3">{{ item?.name || '-' }}</div>
                            </td>
                          </tr>
                        </template>
                        <tr v-else>
                          <td colspan="2" class="text-center">-</td>
                        </tr>
                      </tbody>
                      <thead class="table-light">
                        <tr>
                          <th scope="col">Nilai Penugasan Khusus</th>
                          <!-- <th scope="col">{{ sumNilaiPenugasan(list_penugasan_khusus?.penugasan || []) }}</th> -->
                          <th scope="col">{{ list_penugasan_khusus?.penugasan?.length > 0 ? '0.25' : '0' }}</th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                </form-group>

                <template v-if="['submission', 'resubmission', 'accept_direct_supervisor'].includes(submission_status)">
                  <div
                    v-if="!is_note_penugasan_khusus"
                    class="d-flex justify-content-end gap-4"
                  >
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      @click="is_note_penugasan_khusus = !is_note_penugasan_khusus"
                    >
                      Berikan Catatan
                    </button>
                  </div>

                  <form-group
                    v-if="is_note_penugasan_khusus"
                    label="Tulis Catatan"
                  >
                    <p class="text-sm mb-2">Beri catatan untuk karyawan</p>
                    <textarea
                      v-model="note_penugasan_khusus"
                      class="form-control"
                      rows="5"
                      placeholder="Tulis catatan disini"
                    />
                  </form-group>
                </template>
                <!-- IF SVP -->
                <!-- <div class="row">
                  <div class="col-md-4">
                    <h5>Penugasan Khusus</h5>
                    <p>
                      Masukkan data penugasan sesuai yang diberikan oleh pimpinan atau manajemen di luar jobdesk. Penugasan dapat berupa task karena rangkap jabatan, inovasi, atau kreatifitas.
                    </p>
                  </div>
                  <div class="col-md-8">
                    <div class="d-flex flex-column gap-2">
                      <div class="form-group">
                        <label for="">Silakan tambahkan Penugasan Khusus</label>
                        <div class="d-flex items-align-center justify-content-between gap-2">
                          <div class="flex-grow-1">
                            <input type="text" class="form-control" placeholder="Tulis penugasan khusus disini...">
                          </div>
                          <div>
                            <button class="btn-action btn-action--secondary">Tambahkan</button>
                          </div>
                        </div>
                        <p><small> Contoh, Mengikuti training dalam setiap bulan </small></p>
                      </div>
                      <div class="d-flex flex-column gap-2">
                        <h6>Daftar Penugasan Khusus</h6>
                        <div class="d-flex flex-column gap-4">
                          <div class="d-flex items-align-center justify-content-between gap-2" v-for="index in 4" :key="index">
                            <div class="flex-grow-1">
                              <input type="text" class="form-control" placeholder="Tulis penugasan khusus disini..." value="ini list penugasan khusus">
                            </div>
                            <div>
                              <button class="btn-action btn-action--delete btn-action--delete">
                                <font-awesome-icon icon="fa-solid fa-trash" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div> 
                    </div>
                  </div>
                </div> -->
              </div>

              <div class="tab-pane fade show p-4 pt-0"
                id="pills-pengurangan"
                role="tabpanel"
                aria-labelledby="pills-pengurangan-tab"
              >
                <div
                  v-if="!['submission', 'resubmission'].includes(submission_status)"
                  class="mb-4 d-flex items-center justify-content-between"
                >
                  <h5>Pengurangan</h5>
                  <!-- <span>
                    <i class="fas fa-ellipsis-h cursor-pointer" aria-hidden="true"></i>
                  </span> -->
                </div>

                <template v-if="list_pengurangan?.catatan?.direct?.length > 0">
                  <ArgonAlert
                    v-for="item in list_pengurangan.catatan.direct"
                    :key="item"
                    title="Catatan Atasan 1"
                    color="primary"
                    :dismissible="false"
                  >
                    <p>{{ item?.catatan || '-' }}</p>
                  </ArgonAlert>
                </template>

                <template v-if="list_pengurangan?.catatan?.immediate?.length > 0">
                  <ArgonAlert
                    v-for="item in list_pengurangan.catatan.immediate"
                    :key="item"
                    title="Catatan Atasan 2"
                    color="primary"
                    :dismissible="false"
                  >
                    <p>{{ item?.catatan || '-' }}</p>
                  </ArgonAlert>
                </template>

                <!-- <pre>{{ list_pengurangan }}</pre> -->
                <FieldsetComponent
                  title="Pengurangan"
                  description="Masukkan jumlah sanksi/pengurangan yang diterima dalam satu periode penilaian KPI."
                  v-if="['submission', 'resubmission'].includes(submission_status)"
                >
                  <form-group>
                    <div class="table-responsive">
                      <table class="table align-middle border border-1 border-light">
                        <thead class="table-light">
                          <tr>
                            <th scope="col">Tingkat Permasalahan</th>
                            <th scope="col">Jumlah</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in (list_pengurangan?.pengurangan || list_pengurangan)" :key="index" class="border border-bottom-1 border-light">
                            <td>{{ item?.tingkat_permasalahan ?? "-" }}</td>
                            <td>
                              <form-group>
                                <input
                                  v-if="list_pengurangan?.pengurangan"
                                  v-model="this.list_pengurangan.pengurangan[index].jumlah_permasalahan"
                                  type="number"
                                  min="0"
                                  class="form-control"
                                />
                                <input
                                  v-else
                                  v-model="this.list_pengurangan[index].jumlah_permasalahan"
                                  type="number"
                                  min="0"
                                  class="form-control"
                                />
                              </form-group>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </form-group>
                </FieldsetComponent>

                <form-group v-else>
                  <div class="table-responsive">
                    <table class="table align-middle border border-1 border-light">
                      <thead class="table-light">
                        <tr>
                          <th scope="col">Tingkat Permasalahan</th>
                          <th scope="col">Jumlah</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-if="list_pengurangan?.pengurangan?.length > 0">
                          <tr
                            v-for="(item) in list_pengurangan.pengurangan"
                            :key="item"
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <div class="py-3 px-3">{{ item?.tingkat_permasalahan || '-' }}</div>
                            </td>
                            <td width="10">{{ item?.jumlah_permasalahan || 0 }}</td>
                          </tr>
                        </template>
                        <tr v-else>
                          <td colspan="2" class="text-center">-</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </form-group>

                <template v-if="['submission', 'resubmission', 'accept_direct_supervisor'].includes(submission_status)">
                  <div
                    class="d-flex justify-content-end gap-4"
                  >
                    <button
                      v-if="!is_note_pengurangan"
                      type="button"
                      class="btn btn-outline-secondary"
                      @click="is_note_pengurangan = !is_note_pengurangan"
                    >
                      Berikan Catatan
                    </button>

                    <button
                      v-if="['submission', 'resubmission'].includes(submission_status)"
                      @click="submitPengurangan()"
                      type="button"
                      class="btn btn-secondary"
                    >
                      Submit Pengurangan
                    </button>
                  </div>

                  <form-group
                    v-if="['submission', 'resubmission'].includes(submission_status)"
                    label="Tulis Catatan"
                  >
                    <p class="text-sm mb-2">Beri catatan untuk karyawan</p>
                    <textarea
                      v-model="note_pengurangan"
                      class="form-control"
                      rows="5"
                      placeholder="Tulis catatan disini"
                    />
                  </form-group>
                </template>

                <!-- <div
                  v-if="['submission'].includes(submission_status)"
                  class="d-flex justify-content-end gap-4"
                >
                  <button
                    @click="submitPengurangan()"
                    type="button"
                    class="btn btn-secondary"
                  >
                    Submit Pengurangan
                  </button>
                </div> -->
              </div>

              <div class="tab-pane fade show p-4 pt-0"
                id="pills-kompetensi"
                role="tabpanel"
                aria-labelledby="pills-kompetensi-tab"
              >
                <template v-if="realisasi_kompetensi?.catatan?.direct?.length > 0">
                  <ArgonAlert
                    v-for="item in realisasi_kompetensi.catatan.direct"
                    :key="item"
                    title="Catatan Atasan 1"
                    color="primary"
                    :dismissible="false"
                  >
                    <p>{{ item?.catatan || '-' }}</p>
                  </ArgonAlert>
                </template>

                <template v-if="realisasi_kompetensi?.catatan?.immediate?.length > 0">
                  <ArgonAlert
                    v-for="item in realisasi_kompetensi.catatan.immediate"
                    :key="item"
                    title="Catatan Atasan 2"
                    color="primary"
                    :dismissible="false"
                  >
                    <p>{{ item?.catatan || '-' }}</p>
                  </ArgonAlert>
                </template>

                <template v-if="list_kompetensi_inti.length > 0">
                  <div class="mb-4 d-flex items-center justify-content-between">
                    <h5>Kompetensi Inti</h5>
                    <!-- <span>
                      <i class="fas fa-ellipsis-h cursor-pointer" aria-hidden="true"></i>
                    </span> -->
                  </div>

                  <div
                    v-for="(item, index) in list_kompetensi_inti"
                    :key="item"
                    class="rounded-2 border border-1 p-3 mb-4"
                  >
                    <div class="d-flex justify-content-between items-center">
                      <h6 class="mt-2">{{ item?.name || '-' }}</h6>
                      <form-group v-if="['submission', 'resubmission', 'accept_direct_supervisor'].includes(submission_status)">
                        <input
                          type="number"
                          class="form-control"
                          v-model="list_kompetensi_inti[index].nilai"
                          min="0"
                          max="5"
                          @change="checkLimitInput('inti', index)"
                        >
                      </form-group>
                      <span v-else>{{ item?.nilai || '-' }}</span>
                    </div>

                    <table class="table align-middle border border-1 border-light">
                      <thead class="table-light">
                        <tr>
                          <th scope="col" style="width: 20px;">
                            <small>Level</small>
                          </th>
                          <th scope="col">
                            <small>Deskripsi</small>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <template
                          v-for="(sub, i) in 5"
                          :key="sub"
                        >
                          <tr
                            v-if="item?.['level'+ (i +1)]"
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <span class="px-2">{{ i + 1 }}</span>
                            </td>
                            <td>
                              <p class="mt-3 text-wrap">{{ item?.['level'+ (i +1)] || '-' }}</p>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </template>

                <template v-if="list_kompetensi_manajerial.length > 0">
                  <div class="mt-5 mb-4 d-flex items-center justify-content-between">
                    <h5>Kompetensi Manajerial</h5>
                    <!-- <span>
                      <i class="fas fa-ellipsis-h cursor-pointer" aria-hidden="true"></i>
                    </span> -->
                  </div>

                  <div
                    v-for="(item, index) in list_kompetensi_manajerial"
                    :key="item"
                    class="rounded-2 border border-1 p-3 mb-4"
                  >
                    <div class="d-flex justify-content-between items-center">
                      <h6 class="mt-2">{{ item?.name || '-' }}</h6>
                      <form-group v-if="['submission', 'resubmission', 'accept_direct_supervisor'].includes(submission_status)">
                        <input
                          type="number"
                          class="form-control"
                          v-model="list_kompetensi_manajerial[index].nilai"
                          min="0"
                          max="5"
                          @change="checkLimitInput('manajerial', index)"
                        >
                      </form-group>
                      <span v-else>{{ item?.nilai || '-' }}</span>
                    </div>

                    <table class="table align-middle border border-1 border-light">
                      <thead class="table-light">
                        <tr>
                          <th scope="col" style="width: 20px;">
                            <small>Level</small>
                          </th>
                          <th scope="col">
                            <small>Deskripsi</small>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <template
                          v-for="(sub, i) in 5"
                          :key="sub"
                        >
                          <tr
                            v-if="item?.['level'+ (i +1)]"
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <span class="px-2">{{ i + 1 }}</span>
                            </td>
                            <td>
                              <p class="mt-3 text-wrap">{{ item?.['level'+ (i +1)] || '-' }}</p>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </template>

                <template v-if="['submission', 'resubmission', 'accept_direct_supervisor'].includes(submission_status)">
                  <div
                    v-if="!is_note_kompetensi"
                    class="d-flex justify-content-end gap-4"
                  >
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      @click="is_note_kompetensi = !is_note_kompetensi"
                    >
                      Berikan Catatan
                    </button>
                  </div>

                  <form-group
                    v-if="is_note_kompetensi"
                    label="Tulis Catatan"
                  >
                    <p class="text-sm mb-2">Beri catatan untuk karyawan</p>
                    <textarea
                      v-model="note_kompetensi"
                      class="form-control"
                      rows="5"
                      placeholder="Tulis catatan disini"
                    />
                  </form-group>
                </template>

                <form-group class="mt-3">
                  <div class="table-responsive">
                    <table class="table align-middle border border-1 border-light">
                      <thead class="table-light">
                        <tr>
                          <th scope="col" class="border-bottom-1 border-white">Jumlah</th>
                          <th scope="col" class="border-bottom-1 border-white">{{ total_nilai }}</th>
                        </tr>
                        <tr>
                          <th scope="col" class="border-bottom-1 border-white">Nilai</th>
                          <th scope="col" class="border-bottom-1 border-white" width="60">{{ nilai_kompetensi }}</th>
                        </tr>
                        <tr>
                          <th scope="col">Jumlah Maksimal Jabatan</th>
                          <th scope="col">{{ max_jabatan }}</th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                </form-group>

                  <!-- v-if="['submission', 'resubmission', 'accept_direct_supervisor'].includes(submission_status)" -->
                <div
                  v-if="['submission', 'resubmission'].includes(submission_status)"
                  class="d-flex justify-content-end gap-4"
                >
                  <button
                    @click="submitKompetensi()"
                    type="button"
                    class="btn btn-secondary"
                  >
                    Submit Kompentesi
                  </button>
                </div>
              </div>

              <div class="tab-pane fade show p-4 pt-0"
                id="pills-penilaian-akhir"
                role="tabpanel"
                aria-labelledby="pills-penilaian-akhir-tab"
              >
                
                <div class="mb-4 d-flex items-center justify-content-between">
                  <h5>Penilaian Akhir</h5>
                  <!-- <span>
                    <i class="fas fa-ellipsis-h cursor-pointer" aria-hidden="true"></i>
                  </span> -->
                </div>

                <template v-if="data_penilaian_akhir?.catatan?.direct?.length > 0">
                  <ArgonAlert
                    v-for="item in data_penilaian_akhir.catatan.direct"
                    :key="item"
                    title="Catatan Atasan 1"
                    color="primary"
                    :dismissible="false"
                  >
                    <p>{{ item?.catatan || '-' }}</p>
                  </ArgonAlert>
                </template>

                <template v-if="data_penilaian_akhir?.catatan?.immediate?.length > 0">
                  <ArgonAlert
                    v-for="item in data_penilaian_akhir.catatan.immediate"
                    :key="item"
                    title="Catatan Atasan 2"
                    color="primary"
                    :dismissible="false"
                  >
                    <p>{{ item?.catatan || '-' }}</p>
                  </ArgonAlert>
                </template>

                <form-group>
                  <div class="table-responsive">
                    <table class="table align-middle border border-1 border-light">
                      <thead class="table-light">
                        <tr>
                          <th scope="col">Kategori</th>
                          <th scope="col">Nilai</th>
                          <th scope="col">Bobot</th>
                          <th scope="col">Nilai Akhir</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-if="!data_penilaian_akhir"
                          class="border border-bottom-1 border-light"
                        >
                          <td colspan="4" class="text-center py-4">Submit kompetensi terlebih dahulu.</td>
                        </tr>

                        <template v-else>
                          <tr
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <div class="py-3 px-3">Rata-rata Nilai Kinerja</div>
                            </td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.nilai_kinerja?.average_kinerja || 0 }}</td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.nilai_kinerja?.bobot_kinerja ? data_penilaian_akhir?.penilaian_akhir?.nilai_kinerja?.bobot_kinerja +'%' : 0 }}</td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.nilai_kinerja?.nilai_akhir_kinerja || 0 }}</td>
                          </tr>
                          <tr
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <div class="py-3 px-3">Rata-rata Perilaku Kompetensi</div>
                            </td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.kompetensi?.average_kompetensi || 0 }}</td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.kompetensi?.bobot_kompetensi ? data_penilaian_akhir?.penilaian_akhir?.kompetensi?.bobot_kompetensi +'%' : 0 }}</td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.kompetensi?.nilai_akhir_kompetensi || 0 }}</td>
                          </tr>
                          <tr
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <div class="py-3 px-3">Penugasan Khusus, Rangkap Jabatan, Inovasi & Kreatifitas</div>
                            </td>
                            <td></td>
                            <td></td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.penugasan_khusus || 0 }}</td>
                          </tr>
                          <tr
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <div class="py-3 px-3">Faktor Pengurang KPI</div>
                            </td>
                            <td></td>
                            <td></td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.pengurang || 0 }}</td>
                          </tr>

                        </template>
                      </tbody>
                    </table>
                  </div>
                </form-group>

                <form-group>
                  <div class="table-responsive">
                    <table class="table align-middle border border-1 border-light">
                      <thead class="table-light">
                        <tr
                          class="border border-bottom-1 border-light"
                        >
                          <th scope="col" class="border-bottom-1 border-white">Nilai Akhir</th>
                          <th scope="col" class="border-bottom-1 border-white" width="140">{{ data_penilaian_akhir?.penilaian_akhir?.nilai_akhir || 0 }}</th>
                        </tr>
                        <tr
                          class="border border-bottom-1 border-light"
                        >
                          <th scope="col">Indeks</th>
                          <th scope="col">{{ data_penilaian_akhir?.penilaian_akhir?.indeks || '-' }}</th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                </form-group>

                <template v-if="['submission', 'resubmission', 'accept_direct_supervisor'].includes(submission_status)">
                  <div
                    v-if="!is_note_penilaian_akhir"
                    class="d-flex justify-content-end gap-4"
                  >
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      @click="is_note_penilaian_akhir = !is_note_penilaian_akhir"
                    >
                      Berikan Catatan
                    </button>
                  </div>

                  <form-group
                    v-if="is_note_penilaian_akhir"
                    label="Tulis Catatan"
                  >
                    <p class="text-sm mb-2">Beri catatan untuk karyawan</p>
                    <textarea
                      v-model="note_penilaian_akhir"
                      class="form-control"
                      rows="5"
                      placeholder="Tulis catatan disini"
                    />
                  </form-group>
                </template>
              </div>

            </tabbed-pane>
          </cards>
        </GridCol>
      </GridRow>
    </div>
  </main>
</template>
    
<script>
import Cards from "@/components/CardComponent.vue";
import FormGroup from "@/components/FormGroup.vue";
import FieldsetComponent from "@/components/FieldsetComponent.vue";
// import Select2 from 'vue3-select2-component';
import TabbedPane from "@/components/TabbedPane.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";
import MetaSection from '@/components/MetaSection.vue';
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
// import InputForm from "@/components/InputForm.vue";

import EmployeeApi from "@/repository/api/EmployeeApi";
import PenilaianKpiApi from "@/repository/api/PenilaianKpiApi";
import KpiCompetenciesApi from "@/repository/api/KpiCompetenciesApi";
import KpiPeriodeApi from "@/repository/api/KpiPeriodeApi";
import KpiRealisasiApi from "@/repository/api/KpiRealisasiApi";
import PenguranganApi from "@/repository/api/PenguranganApi";

export default {
  name: "realisasi-target",
  components: {
    FieldsetComponent,
    FormGroup,
    Cards,
    TabbedPane,
    // ArgonButton,
    MetaSection,
    GridRow,
    GridCol,
    // InputForm,
    ArgonAlert,
  },
  data() {
    return {
      data: {
        periode_id: "",
      },
      nip: "",
      kpiperiode: [],
      realisasikpi: [{}],
      timer: undefined,

      tabs: {
        'Penilaian Kinerja':true,
        'Penugasan Khusus':false,
        'Pengurangan':false,
        'Kompetensi':false,
        'Penilaian Akhir':false
      },

      periode_active: null,
      employee: null,
      employee_id_login: null,

      list_penilaian_kinerja: [],
      is_note_penilaian_kinerja: false,
      note_penilaian_kinerja: '',
      
      list_penugasan_khusus: [],
      is_note_penugasan_khusus: false,
      note_penugasan_khusus: '',

      list_pengurangan: [],
      is_note_pengurangan: false,
      note_pengurangan: '',

      list_kompetensi_inti: [],
      list_kompetensi_manajerial: [],
      is_note_kompetensi: false,
      note_kompetensi: '',

      realisasi_kompetensi: null,

      data_penilaian_akhir: null,
      is_note_penilaian_akhir: false,
      note_penilaian_akhir: '',

      direct_leave: false,
    };
  },
  computed: {
    employee_id() {
      return this.$route.params.employee_id;
    },
    realization_id() {
      return this.$route.params.realization_id;
    },
    submission_status() {
      return this.$route.params.submission_status;
    },
    periode_id() {
      return this.$route.params.periode_id;
    },
    total_nilai() {
      let total = 0;

      if (this.list_kompetensi_inti.length > 0) {
        this.list_kompetensi_inti.forEach(item => {
          total += item.nilai;
        });
      }

      if (this.list_kompetensi_manajerial.length > 0) {
        this.list_kompetensi_manajerial.forEach(item => {
          total += item.nilai;
        });
      }

      return total;
    },
    
    nilai_kompetensi() {
      let total = 0;
      total = (this.total_nilai / this.max_jabatan) * 5;
      if (!Number.isInteger(total)) total = total.toFixed(2);
      return total;
    },
    max_jabatan() {
      let total = 0;
      let inti = this.employee?.jabatan?.inti || 0;
      let manajerial = this.employee?.jabatan?.manajerial || 0;

      total = (inti * 5) + (manajerial * 5);
      if (!Number.isInteger(total)) total = total.toFixed(2);
      return total;
    },
  },
  watch: {
    total_nilai() {},
    nilai_kompetensi() {},
    max_jabatan() {},
  },
  methods: {
    // openNoteModal(index) {
    //   this.step_1_detail_index = index;
    // },
    sumBobotSubKpi(data) {
      data = data.map((item) => Number.parseFloat(item?.bobot || 0));
      data = data.reduce((a, b) => a + b, 0);
      return data;
    },
    sumNilaiPenugasan(data) {
      data = data.map((item) => Number.parseFloat(item?.nilai || 0));
      data = data.reduce((a, b) => a + b, 0);
      return data;
    },

    async getKpiPeriode() {
      console.log('this.periode_id', this.periode_id)
      await KpiPeriodeApi.get(this.periode_id)
        .then((response) => {
          this.periode_active = response?.data || {};
        })
        .catch((err) => {
          console.log(err)
        });
    },
    async getEmployee() {
      await EmployeeApi.get(this.employee_id)
        .then((resp) => {
          this.employee = resp?.data;
        })
        .catch((err) => {
          console.log(err)
        });
      
      await this.getSessionUser();
      console.log(this.$store.state?.sessionUser);
      console.log('\nthis.employee');
      console.log(this.employee);
      this.employee_id_login = this.$store.state?.sessionUser?.employee?.id || '';
    },

    async getPenilaianKpi() {
      await PenilaianKpiApi.getDetailPenilaianKinerja({
        realization_id: this.realization_id,
      })
        .then((resp) => {
          this.list_penilaian_kinerja = resp?.data;
        })
        .catch((err) => {
          console.log(err)
        });
    },

    async getPenugasanKhusus() {
      await PenilaianKpiApi.getDetailPenugasanKhusus({
        employee_id: this.employee_id,
        realization_id: this.realization_id,
      })
        .then((resp) => {
          this.list_penugasan_khusus = resp?.data;
        })
        .catch((err) => {
          console.log(err)
        });
    },

    async getPengurangan() {
      await PenilaianKpiApi.getDetailPengurangan({
        employee_id: this.employee_id,
        realization_id: this.realization_id,
      })
        .then((resp) => {
          this.list_pengurangan = resp?.data;
        })
        .catch((err) => {
          console.log(err)
        });
    },

    async getKompetensi() {
      // master kompetensi
      // await KpiCompetenciesApi.get()
      await KpiCompetenciesApi.getbyparam({
        limit: 100,
        status: 'active',
        type: this.employee.jabatan.jenis_kompetensi,
      })
        .then((resp) => {
          const list = resp?.data ? resp.data.map(item => { item.nilai = 0; return item; }) : [];
          // console.log(list)

          this.list_kompetensi_inti = list.filter(item => item?.type === 'inti');
          this.list_kompetensi_manajerial = list.filter(item => item?.type === 'manajerial');
        })
        .catch((err) => {
          console.log(err)
        });

      // saved value kompetensi is exist
      await PenilaianKpiApi.getDetailKompetensi({
        realization_id: this.realization_id,
        employee_id: this.employee_id,
      })
      .then((resp) => {
        // console.log(list)
          this.realisasi_kompetensi = resp?.data || null;

          console.log('this.realisasi_kompetensi', this.realisasi_kompetensi)
          console.log('this.list_kompetensi_inti', this.list_kompetensi_inti)
          console.log('this.list_kompetensi_manajerial', this.list_kompetensi_manajerial)

          if (this.realisasi_kompetensi?.kompetensi?.[0]?.nilai_perkompetensi?.length > 0) {

            for (let index = 0; index < this.realisasi_kompetensi.kompetensi[0].nilai_perkompetensi.length; index++) {
              const kpi_saved = this.realisasi_kompetensi.kompetensi[0].nilai_perkompetensi[index];
              console.log(kpi_saved)
              
              const filter_kompetensi_inti = this.list_kompetensi_inti.filter(item => item.id === kpi_saved.kompetensi_id);
              if (filter_kompetensi_inti.length > 0) {
                const index_inti = this.list_kompetensi_inti.indexOf(filter_kompetensi_inti[0]);
                this.list_kompetensi_inti[index_inti].nilai = kpi_saved.nilai;
                
              } else {
                const filter_kompetensi_manajerial = this.list_kompetensi_manajerial.filter(item => item.id === kpi_saved.kompetensi_id);

                if (filter_kompetensi_manajerial.length > 0) {
                  const index_manajerial = this.list_kompetensi_manajerial.indexOf(filter_kompetensi_manajerial[0]);
                  this.list_kompetensi_manajerial[index_manajerial].nilai = kpi_saved.nilai;
                } 
              }
            }
          }
        })
        .catch((err) => {
          console.log(err)
        });
    },

    async getPenilaianAkhir() {
      // await PenilaianKpiApi.getDetailKompetensi({
      // await KpiCompetenciesApi.get()
      await PenilaianKpiApi.getPenilaianAkhir({
        employee_id: this.employee_id,
        realization_id: this.realization_id,
      })
        .then((resp) => {
          // console.log(resp?.data)
          this.data_penilaian_akhir = resp?.data || null;
        })
        .catch((err) => {
          console.log(err)
          // this.data_penilaian_akhir = err?.response?.data || null;
        });
    },

    async getData() {
      this.$store.state.loading = true;
      
      try {

        await this.getEmployee();
        await this.getPenilaianKpi();
        await this.getPenugasanKhusus();
        await this.getPengurangan();
        await this.getKompetensi();

        await this.getPenilaianAkhir()

        this.$store.state.loading = false;
        
      } catch (error) {
        console.log(error)
        this.$store.state.loading = false;
      }
    },

    async checkLimitInput(type, index) {
      this.$store.state.loading = true;

      await PenilaianKpiApi.checkLimitInput({
        employee_id: this.employee_id,
        type,
        // type: this.employee.jabatan.jenis_kompetensi,
        nilai: (type === 'inti' ? this.list_kompetensi_inti[index].nilai : this.list_kompetensi_manajerial[index].nilai),
        realization_id: this.realization_id, 
      })
        .then((resp) => {
          console.log(resp)
        })
        .catch((err) => {
          console.log(err)
          if (err?.response?.status === 412) {

            this.$swal({
              icon: "warning",
              title: err?.response?.data?.message,
            });

            if (type === 'inti') this.list_kompetensi_inti[index].nilai = err?.response?.data?.data?.[0]?.inti || 0;
            else this.list_kompetensi_manajerial[index].nilai = err?.response?.data?.data?.[0]?.manajerial || 0;

          } else {

            this.$swal({
              icon: "warning",
              title: 'Something wrong, please try again.',
            });

            if (type === 'inti') this.list_kompetensi_inti[index].nilai = 0;
            else this.list_kompetensi_manajerial[index].nilai = 0;
          }
        });

      this.$store.state.loading = false;
    },

    async submitKompetensi() {
      this.$swal({
        icon: "warning",
        title: "Submit data kompetensi?",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$store.state.loading = true;

          let kompetensi = [];
          
          if (this.list_kompetensi_inti) {
            this.list_kompetensi_inti.forEach(item => {
              kompetensi.push({
                id_kompetensi: item.id,
                type: item.type,
                nilai: item.nilai,
              })
            });
          }

          if (this.list_kompetensi_manajerial) {
            this.list_kompetensi_manajerial.forEach(item => {
              kompetensi.push({
                id_kompetensi: item.id,
                type: item.type,
                nilai: item.nilai,
              })
            });
          }

          await PenilaianKpiApi.addKompetensi({
            employee_id: this.employee_id,
            realization_id: this.realization_id,
            kompetensi: JSON.stringify(kompetensi),
          })
            .then((resp) => {
              console.log(resp)
              this.getPenilaianAkhir();

              this.$swal({
                icon: "success",
                title: 'Kompetensi berhasil disimpan.',
                text: 'Silahkan cek penilaian akhir.',
              });
            })
            .catch((err) => {
              console.log(err)

              this.$swal({
                icon: "error",
                title: 'Something wrong, please try again!',
              });
            });

          this.$store.state.loading = false;
        }
      });
    },

    async submitPengurangan() {
      let pengurangan = JSON.parse(JSON.stringify(this.list_pengurangan?.pengurangan ? this.list_pengurangan.pengurangan : this.list_pengurangan));
      const list_nilai = pengurangan.map(item => item.jumlah_permasalahan);
      let next = true;

      if (list_nilai.every( (val) => val === 0 )) {
        await this.$swal({
          icon: "warning",
          title: "Anda yakin tidak ada nilai pengurangan?",
          text: "Mohon periksa kembali sebelum menerima atau menolak.",
          showCancelButton: true,
        }).then(async (result) => {
          if (!result.isConfirmed) {
            next = false;
          }
        });

        if (!next) {
          return;
        }
      }

      this.$store.state.loading = true;

      pengurangan = pengurangan.map(item => {
        return {
          id: (this.list_pengurangan?.pengurangan ? item.pengurangan_id : item.id),
          nilai: item?.nilai || 0,
          tingkat_permasalahan: item.tingkat_permasalahan,
          jumlah_permasalahan: item.jumlah_permasalahan,
        }
      });
      
      await KpiRealisasiApi.addRealisasiPengurangan({
        employee_id: this.employee_id,
        realization_id: this.realization_id,
        pengurangan: JSON.stringify(pengurangan),
      })
        .then((resp) => {
          console.log(resp?.data)
          this.getPenilaianAkhir();

          this.$swal({
            icon: "success",
            title: 'Pengurangan berhasil disimpan.',
          });
        })
        .catch((error) => {
          // console.log(error)
            // throw error;
          this.$swal({
            icon: "error",
            title: error?.response?.data?.message || 'Something wrong, please try again.',
          });
        });
      
      this.$store.state.loading = false;
    },

    async submitNote(note, apiMethod, is_from_immediate) {
      if (!note) return;

      await apiMethod({
        realization_id: this.realization_id,
        is_from_immediate,
        catatan: note,
      }).catch((err) => {
        throw err;
      });
    },

    async submitPenilaian(is_accept) {

      if (!this.data_penilaian_akhir) {
        this.$swal({
          icon: "warning",
          title: 'Submit pengurangan & kompetensi terlebih dahulu!',
        });

        return;
      }

      if (!is_accept && (!this.note_penilaian_kinerja && !this.note_penugasan_khusus && !this.note_pengurangan && !this.note_kompetensi && !this.note_penilaian_akhir)) {
        this.$swal({
          icon: "error",
          title: 'Catatan Dibutuhkan',
          text: 'Beri catatan pada salah satu komponen yang belum sesuai.',
        });

        return;
      }

      // console.log('prevent tolak/terima')
      // return;
      // eslint-disable-next-line no-unreachable
      this.$swal({
          icon: "warning",
          title: "Anda yakin ingin "+ (is_accept ? 'menerima' : 'menolak') +" penilaian ini?",
          showCancelButton: true,
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              this.$store.state.loading = true;

              const prefix_penilaian = is_accept ? 'accept' : 'reject';
              let keputusan = '';
              let is_from_immediate = false;

              switch (this.submission_status) {
                case 'submission':
                  keputusan = prefix_penilaian +'_direct_supervisor';
                  break;

                case 'resubmission':
                  keputusan = prefix_penilaian +'_direct_supervisor';
                  break;

                case 'accept_direct_supervisor':
                  keputusan = prefix_penilaian +'_immediate_supervisor';
                  is_from_immediate = true;
                  break;
              
                default:
                  break;
              }

              // submit all note
              await this.submitNote(this.note_penilaian_kinerja, PenilaianKpiApi.addNotePenilaianKinerja, is_from_immediate);
              await this.submitNote(this.note_penugasan_khusus, PenilaianKpiApi.addNotePenugasanKhusus, is_from_immediate);
              await this.submitNote(this.note_pengurangan, PenilaianKpiApi.addNotePengurangan, is_from_immediate);
              await this.submitNote(this.note_kompetensi, PenilaianKpiApi.addNoteKompetensi, is_from_immediate);
              await this.submitNote(this.note_penilaian_akhir, PenilaianKpiApi.addNotePenilaianAkhir, is_from_immediate);
    
              // submit tolak/terima
              await PenilaianKpiApi.submitKeputusan({
                employee_id: this.employee_id,
                realization_id: this.realization_id,
                keputusan,
                created_by: this.employee_id_login,
              })
                .then((resp) => {
                  console.log(resp)
                  
                  this.direct_leave = true;
                  this.$router.push({ name: 'Penilaian KPI' });
                })
                .catch((err) => {
                  // console.log(err)
                  throw err;
                });

              this.$store.state.loading = false;
              
            } catch (error) {
              console.log(error)
              this.$store.state.loading = false;
              this.$swal({
                icon: "error",
                title: error?.response?.data?.message || 'Something wrong, please try again.',
              });
            }
          }
        });
    },

    async forwardToEmployee() {
      this.$swal({
        icon: "warning",
        title: "Lanjutkan KPI ke pegawai?",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$store.state.loading = true;

          await PenilaianKpiApi.submitKeputusan({
            employee_id: this.employee_id,
            realization_id: this.realization_id,
            keputusan: 'reject_direct_supervisor',
            created_by: this.employee_id_login,
          })
            .then((resp) => {
              console.log(resp)

              this.direct_leave = true;
              this.$router.push({ name: 'Penilaian KPI' });

              this.$swal({
                icon: "success",
                title: 'KPI telah diarahkan ke pegawai untuk direvisi.',
              });
            })
            .catch((err) => {
              console.log(err)

              this.$swal({
                icon: "error",
                title: 'Something wrong, please try again!',
              });
            });

          this.$store.state.loading = false;
        }
      });
    },

    async getMasterPengurangan() {
      await PenguranganApi.get()
        .then((resp) => {
          if (resp?.data) {
            for (let i = 0; i < resp.data.length; i++) {
              const item = resp.data[i];
              
              this.list_pengurangan.push({
                id: item.id,
                tingkat_permasalahan: item.tingkat_permasalahan,
                nilai: item.nilai,
                jumlah_permasalahan: 0,
              })
            }
          }
        })
        .catch((err) => {
          console.log(err)
        });
    },
  },

  // beforeRouteLeave (to, from, next) {
  beforeRouteLeave (to, from, next) {
    // const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
    // if (!answer) return false

    // console.log('beforeRouteLeave', to, from)

    if (!this.direct_leave) {
      this.$swal({
          icon: "warning",
          title: "Anda yakin ingin keluar dari halaman ini?",
          text: "Data peniaian belum diputuskan apakah diterima atau ditolak.",
          showCancelButton: true,
        }).then(async (result) => {
          if (result.isConfirmed) {
            console.log('stay here')
            next();
          } else {
            next(false);
          }
        });
    } else {
      next();
    }
  },
  async mounted() {
    this.getKpiPeriode();
    this.getData();
    if ([
      // 'submission',
      'resubmission',
      'reject_direct_supervisor',
      // 'accept_direct_supervisor',
      'revisi_direct_supervisor',
      'reject_immediate_supervisor',
      'accept_immediate_supervisor'
    ].includes(this.submission_status)) {
      this.direct_leave = true;
    }


    if ([
      'submission',
      'resubmission',
    ].includes(this.submission_status)) {
      this.getMasterPengurangan();
    }
  },
};
</script>
    